// import xxx, {yyy} from '...' - xxx是默认导入， yyy 按需导入
import router from "@/router";
import store from "@/store";
import * as dd from "dingtalk-jsapi";
import { Message } from "element-ui";
// import { errorMsg } from "@/api/design";
import { version } from "../globalConfig.json";
const whiteList = ["/login", "/detail", "/site/home", "/site2/home", '/site/template', '/site/product', '/site/scheme'];

let isPhone = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

let toPath = (token) => {
  if (process.env.NODE_ENV == "development") {
    window.location.href = `http://192.168.2.53:8080/#/pages/index/index?token=${token}`; // 开发环境
  } else if (process.env.NODE_ENV == "production" && window.location.href.includes("http://test")) {
    window.location.href = `http://test.cloud.yibeirui.com/h5/index.html#/pages/index/index?token=${token}`; // 测试环境
  } else {
    window.location.href = `http://cloud.yibeirui.com/h5/index.html#/pages/index/index?token=${token}`; // 生产环境
  }
};

//钉钉登陆清除本地缓存
try {
  if (dd && dd.env && dd.env.platform !== "notInDingTalk") {
    Message({
      message: "检测到钉钉环境，正在清除本地缓存...",
      type: "info",
    });
    store.commit("user/setToken", "");
    store.commit("user/setUserInfo", {});
    localStorage.clear();
    Message.success("本地缓存已清除");
  } else {
    Message({
      message: "钉钉环境检测失败，已跳过缓存清除",
      type: "info",
    });
  }
} catch (err) {
  console.log("钉钉环境检测异常，已跳过缓存清除：", err);
}


router.beforeEach(async (to, from, next) => {
  if (dd.env.platform !== "notInDingTalk") {
    if (isPhone && to.path === "/detail") {
      const loadingMsg = Message({
        message: "正在获取钉钉授权码...",
        type: "info",
        duration: 0,
      });
      dd.getAuthCode({
        corpId: "ding8ade6b5e21085cf135c2f4657eb6378f",
        success: async function (res) {
          loadingMsg.close();
          Message.success("已获取钉钉授权码");
          const tokenMsg = Message({
            message: "正在换取登录凭证...",
            type: "info",
            duration: 0,
          });
          try {
            let token = await store.dispatch("user/isDDLogin", res.code);
            tokenMsg.close();
            Message.success("登录凭证获取成功，正在跳转...");
            // this.toPath(token.data);
            window.location.href = `http://cloud.yibeirui.com/h5/index.html#/pages/list/listDetail?token=${token}&code=${to.query.code}&objId=${to.query.objId}`; // 生产环境
          } catch (err) {
            tokenMsg.close();
            Message.error("登录凭证获取失败，请重试");
            console.log(err, "err");
          }
        },
        fail: function (err) {
          loadingMsg.close();
          Message.error("获取钉钉授权码失败，请重试");
          console.log(err, "err");
        },
      });
    }
  }
  const historyVersion = localStorage.getItem("version"); // 版本号
  if (historyVersion !== version) {
    localStorage.clear();
    store.commit("user/setToken", '');
    localStorage.setItem("version", version);
  }

  const token = store.getters.token;
  if (token) {
    // 已登录
    if (isPhone) {
      toPath(token);
    } else {
      if (to.path === "/login") {
        // 是登录页
        next("/");
      } else {
        next();
      }
    }
  } else {
    if (whiteList.includes(to.path)) {
      if (to.path === "/login" && isPhone) {
        toPath(token);
      } else {
        next();
      }
    } else {
      if (dd.env.platform !== "notInDingTalk") {

        //进行钉钉登录操作
        const loadingMsg = Message({
          message: "正在获取钉钉授权码...",
          type: "info",
          duration: 0,
        });
        dd.getAuthCode({
          corpId: "ding8ade6b5e21085cf135c2f4657eb6378f",
          success: async function (res) {
            loadingMsg.close();
            Message.success("已获取钉钉授权码");
            const tokenMsg = Message({
              message: "正在换取登录凭证...",
              type: "info",
              duration: 0,
            });
            try {
              let token = await store.dispatch("user/isDDLogin", res.code);
              tokenMsg.close();
              Message.success("登录凭证获取成功");
              const redirectMsg = Message({
                message: "登录成功，正在跳转...",
                type: "success",
                duration: 0,
              });
              if (isPhone) {
                toPath(token);
              } else {
                next("/home");
              }
              setTimeout(() => redirectMsg.close(), 1000);
            } catch (err) {
              tokenMsg.close();
              Message.error("登录凭证获取失败，请重试");
              console.log(err, "err");
            }
          },
          fail: function (err) {
            loadingMsg.close();
            Message.error("获取钉钉授权码失败，请重试");
            console.log(err, "err");
          },
        });
      } else {
        if (to.query.ddToken) {
          localStorage.clear();
          //  context.commit("setToken", "");
          store.commit("user/setToken", null);
          //  context.commit("setUserInfo", {});
          store.commit("user/setToken", to.query.ddToken);
          store.dispatch("user/getUserInfo");
          next(`/home?code=${to.query.code}`);
        } else {
          next("/login");
        }
      }
    }
  }
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.meta.content) {
    let head = document.getElementByTagName("head");
    let meta = document.createElemnet("meta");
    meta.name = "viewport";
    meta.content = "width=device-width, initial-scale=1.0, user-scalable=no";
    head[0].appendChild(meta);
  }
});
